export class VendorStatisticsRequest {
    DateTimeStart: Date;
    DateTimeEnd: Date;
    VendorID: number;
    Material: string;
}
